import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionService } from '@com-delta-idp/mnx-oauth';
import {
  EndpointKeys,
  IDP_APPS,
  Libraries
} from '@com-delta-idp/mnx-skymiles-shared';
import {
  ApiBuilder,
  AppConfigService,
  CustomError,
  HttpRequestMethods,
  handleError,
  logCustomError
} from '@com-delta-idp/mnx-utils';
import { Observable, of, throwError } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  CommonRequest,
  PayloadRequest,
  StatusTrackerResponse
} from '../../models/api/tracker.interfaces';
import {
  COMMON_HEADER_KEY,
  commonHeaderInfo
} from '../../models/overview.constants';

@Injectable({
  providedIn: 'root'
})
export class StatusTrackerService {
  errorHandler = handleError.bind(this);

  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private session: SessionService
  ) {}

  getStatusTrackerResponse = (
    request: CommonRequest
  ): Observable<StatusTrackerResponse | undefined> => {
    const payload: PayloadRequest = { carrierCode: request.carrierCode };
    commonHeaderInfo['X-Delta-DLCOM_Loyalty_App_Test'] = COMMON_HEADER_KEY;
    commonHeaderInfo['Authorization'] = this.session.token.access_token;
    if (request.carrierCode) {
      return new ApiBuilder<
        PayloadRequest,
        StatusTrackerResponse | CustomError
      >(this.http, this.appConfig)
        .app(IDP_APPS.SKYMILES)
        .endpointKey(EndpointKeys['SKYMILES_API_STATUS_TRACKER'])
        .method(HttpRequestMethods['POST'])
        .payload(payload)
        .httpHeaders(commonHeaderInfo)
        .timeOut(request.timeout)
        .errorHandler(this.errorHandler)
        .retries(request.retry)
        .library(Libraries.OVERVIEW)
        .withCredentials(true)
        .create()
        .pipe(
          map((response: StatusTrackerResponse | CustomError) => {
            return this.existCustomError(response);
          })
        );
    }
    return of(undefined);
  };

  existCustomError(
    response: StatusTrackerResponse | CustomError
  ): StatusTrackerResponse {
    if ('errorResponse' in response) {
      logCustomError(
        response.errorResponse,
        IDP_APPS.SKYMILES,
        Libraries.OVERVIEW,
        EndpointKeys.SKYMILES_API_STATUS_TRACKER
      );
      throw throwError(response);
    }
    return response;
  }
}
